import React, { Component } from 'react';
import AddProductMapping from './addDedicatedProductMapping';
import ACTIONS from '../../../../common/action_constant';
import { connect } from 'react-redux';
import Search from 'src/common/components/search-text/search-text';
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import { getEmail, getUserId } from 'Utils/common';
import LoaderComponent from 'src/common/components/loader/loader';
import { ToastContainer, toast } from 'react-toastify';

const rowObj = {
  accepted_product_list: [
    {
      product:'',
      product_code: '',
      is_pharma: false
    }
  ],
  product: "",
  product_code: ""
}

class ProductMapping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      row: {},
      search: '',
      isEdit: false,
      materialList: []
    };
  }

  componentDidMount() {
    this.getDedicatedProducts();
  }

  getDedicatedProducts = () => {
    const { dispatch, companyId, branchId } = this.props;
    const { search } = this.state;
    const params = {
      companyId,
      branchId
    }
    if(search) {
      params.search = search
    }
    dispatch({
      type: ACTIONS.PLANTS.GET_DEDICATED_PRODUCT_MASTER,
      params,
      onSuccess: (data) => {
        this.setState({
          materialList: data || []
        })
      },
      onError: (e) => {
          toast.error(e?.response?.data?.message || "Something went wrong");
      }
    })
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  onHandleAdd = () => {
    const { companyId, branchId } = this.props;
    this.setState ({
      isOpen: true,
      isEdit: false,
      row: {
        company_id: companyId,
        branch_id: branchId,
        ...rowObj
      }
    })
  }

  onHandleEdit = (el) => {
    this.setState ({
      isOpen: true,
      isEdit: true,
      row: el
    })
  }

  handleSave = (savedRow) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.ADD_DEDICATED_PRODUCT_MASTER,
      payload: {
        email: getEmail(),
        user_id: getUserId(),
        ...savedRow
      },
      onSuccess: (e) => {
        this.setState({
          isOpen: false
        });
        toast.success(e?.data?.message || 'Data Added Successfully')
        this.getDedicatedProducts();
      },
      onError: (e) => {
        toast.error(e?.response?.data?.message || "Something went wrong");
      }
    })
    
    this.setState({ row: savedRow, isOpen: false });
  };

  getProductData = (search) => {
    const { dispatch } = this.props;
    let params = `?companyId=${this.props.companyId}&search=${search}&offset=${0}&limit=${10}`
    dispatch({
        type: ACTIONS.MASTER.INVENTORY_ITEM.GET_TOLERANCE_LIST_DATA,
        params,
        onSuccess: (data) => {
            this.setState({ productOptions: data})
        }
    })
  }

  onClickSearch = () => {
    this.getDedicatedProducts();
  }

  onHandleClearFilter = () => {
    this.setState({
      search: ''
    }, this.getDedicatedProducts)
  }

  onChangeSearch = (e) => {
    this.setState({
      search: e
    })
  }

  onUpdate = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.UPDATE_DEDICATED_PRODUCT_MASTER,
      payload: {
        email: getEmail(),
        user_id: getUserId(),
        ...data
      },
      onSuccess: (e) => {
        this.setState({
          isOpen: false,
          row: {},
          isEdit: false
        });
        this.setState({
          isOpen: false
        });
        toast.success(e?.data?.message || 'Data Updated Successfully')
        this.getDedicatedProducts();
      },
      onError: (e) => {
        toast.error(e?.response?.data?.message || "Something went wrong");
      }
    })
  }

  handleDelete = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.DELETE_DEDICATED_PRODUCT_MASTER,
      payload: {
        email: getEmail(),
        user_id: getUserId(),
        ...data
      },
      onSuccess: (e) => {
        this.setState({
          isOpen: false
        });
        toast.success(e?.data?.message || 'Data Deleted Successfully')
        this.getDedicatedProducts();
      },
      onError: (e) => {
        toast.error(e?.response?.data?.message || "Something went wrong");
      }
    })
  }

  render() {
    const { isOpen, row, productOptions, isEdit, materialList } = this.state;
    const { companyId, branchId, loader } = this.props;
    return (
      <div className="product-mapping-page">
        {!!loader.loaderT1 && <LoaderComponent />}
        <ToastContainer />
        <div className={"flex flex-between"}>
            <div style={{display: 'block', paddingBottom: '15px'}}>
                <Search id = "search" value = {this.state.search} placeholder = "Search..." changeHandler = {this.onChangeSearch} click = {this.onClickSearch} canClear={this.state.search !== ''} handleClearFilter={this.onHandleClearFilter}/>
            </div>
            <div className="page-actions">
                <div className="add-button" onClick={this.onHandleAdd}>Add Dedicated Product</div>
            </div>
        </div>
        <div className="dedicated-table">
          <table style={{'width': '100%', 'border': 'none'}} >
              <tr>
                  <th>Product</th>
                  <th>Product</th>
                  <th>Pharma</th>
                  <th>Actions</th>
              </tr>
              {(materialList || []).map((material, mIndex) => (
                <>
                {(material.accepted_product_list || []).map((el, index) => ( 
                  <tr>
                    {(index == 0) && <td rowSpan={material.accepted_product_list.length}>{material.product}</td>}
                    <td>{el.product}</td>
                    <td>{el.is_pharma ? 'Yes' : 'No'}</td>
                    {(index == 0) && <td rowSpan={material.accepted_product_list.length}>
                        <div className="delete-icon" style={{ backgroundImage: `url(${Edit})` }} onClick={() => this.onHandleEdit(material)}></div>
                        <div className="delete-icon" style={{ backgroundImage: `url(${Delete})` }} onClick={() => this.handleDelete(material)}></div>
                    </td>}
                  </tr> ))}
                </>))}
          </table>
        </div>

        <AddProductMapping
          isOpen={isOpen}
          title={`${isEdit? 'Edit' : 'Add'} Dedicated Product`}
          productOptions={productOptions}
          company_id={companyId}
          branch_id={branchId}
          getProductData={this.getProductData}
          onClose={this.closeModal}
          onSave={this.handleSave}
          row={row}
          isEdit={isEdit}
          handleUpdate={this.onUpdate}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
	return {
		loader: state.loader,
	};
};

export default connect(mapStateToProps)(ProductMapping);
